"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RichTextEditor = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _urls = require("../../utilities/urls");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _RichTextEditor = _interopRequireDefault(require("./RichTextEditor.styles"));
var _RichTextEditor2 = require("./RichTextEditor.helpers");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
window.cet = window.cet || {};
window.cet.cc_data = window.cet.cc_data || {};
window.cet.cc_data.tinymce = window.cet.cc_data.tinymce || {
  indexId: 0,
  counter: 0
};
const useScriptsList = {
  scriptsList: [{
    src: `${_urls.cdnUrl}/libs/jquery/2.1.1/jquery-2.1.1.min.js`,
    checkIfAlreadyLoaded: () => !!window.jQuery,
    isWaitUntilLoaded: true
  }, {
    src: `${_urls.cdnUrl}/libs/tinymcePresets/2/tinymcePresets.bundle.min.js`,
    checkIfAlreadyLoaded: () => !!(window.cet && window.cet.tinymcePresets && window.cet.tinymcePresets.presets)
  }, {
    src: `${_urls.cdnUrl}/libs/tinymce.view.modules/1.0/tinymceViewModules.bundle.min.js`,
    checkIfAlreadyLoaded: () => !!(window.cet && window.cet.uploadfileapi)
  }, {
    src: `${_urls.cdnUrl}/libs/tinymce/4.2.8/tinymce.min.js`,
    checkIfAlreadyLoaded: () => !!window.tinymce
  }]
};
const RichTextEditor = props => {
  const {
    htmlFontSize
  } = (0, _hooks.useDeviceData)();
  const {
    language,
    direction,
    basicFontSize,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    placeholder = '',
    content = '',
    isReadOnly = false,
    isWithAutoResize = false,
    height = '100%',
    onChanged
  } = props;
  const {
    isReady: isScriptsReady,
    error
  } = (0, _hooks.useScripts)(useScriptsList);
  const {
    getMeasurement
  } = (0, _hooks.useStylesUtils)();
  const styles = (0, _RichTextEditor.default)(props);
  const [id, setId] = (0, _react.useState)();
  const tinyContent = (0, _react.useRef)(content);
  const tinyEditor = (0, _react.useRef)(null);
  const onChangedRef = (0, _react.useRef)(value => {});
  const handleEditorInit = (0, _react.useCallback)(editor => {
    const iframe = editor.iframeElement;
    iframe.style.height = getMeasurement(height);
    if (height === '100%') {
      (0, _RichTextEditor2.setTinymceFullHeight)(iframe);
    }
    const onChangedHandler = () => {
      if (editor) {
        const content = editor.getContent({
          format: 'raw'
        });
        if (content !== tinyContent.current) {
          tinyContent.current = content;
          if (onChangedRef) onChangedRef.current(content);
        }
      }
    };
    editor.on('input blur cut focusout paste ExecCommand', onChangedHandler);
  }, [getMeasurement, height]);
  (0, _react.useEffect)(() => {
    window.cet.cc_data.tinymce.counter++;
    window.cet.cc_data.tinymce.indexId++;
    const indexId = window.cet.cc_data.tinymce.indexId;
    setId(`cc_tinymce_indexId__${indexId}`);
    return () => {
      window.cet.cc_data.tinymce.counter--;
      if (tinyEditor.current) {
        tinyEditor.current.remove();
      }
      tinyEditor.current = null;
    };
  }, []);
  (0, _react.useEffect)(() => {
    onChangedRef.current = onChanged || (value => {});
  }, [onChanged]);
  (0, _react.useEffect)(() => {
    if (isScriptsReady && !error && id) {
      if (window.tinymce.get(id) !== null) {
        window.tinymce.get(id).remove();
      }
      tinyEditor.current = null;
      let tinymceOptions = window.cet.tinymcePresets.getTinymcePreset('default', '#' + id, language, {
        directionality: direction
      });
      tinymceOptions.setup = function (editor) {
        tinyEditor.current = editor;
        editor.on('BeforeSetContent', _RichTextEditor2.cleanContent);
        editor.on('init', () => {
          handleEditorInit(editor);
        });
      };
      tinymceOptions.readonly = isReadOnly;
      if (!isWithAutoResize || height === '100%') {
        (0, _RichTextEditor2.removeAutoResize)(tinymceOptions);
      }
      tinymceOptions.content_style = (tinymceOptions.content_style || '') + ` html {font-size: ${htmlFontSize}} body.tiny-body {color: ${themeColors?.general.text}; font-size: ${basicFontSize}; font-family: sans-serif; line-height: 1.5;}`;
      window.tinymce.init(tinymceOptions);
    }
  }, [basicFontSize, direction, error, handleEditorInit, height, htmlFontSize, id, isReadOnly, isScriptsReady, isWithAutoResize, language, themeColors?.general.text]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-RichTextEditor'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
      "data-testid": "ccRichTextEditorContent",
      id: id,
      placeholder: placeholder,
      defaultValue: tinyContent.current
    })
  });
};
exports.RichTextEditor = RichTextEditor;